/** Shared design constants for Crossroads to Change Residential Treatment Center */
export const IMG = {
    // Hero — Black mentor with a young man in a learning moment (diverse, mentorship-focused)
    hero: "https://images.pexels.com/photos/8617761/pexels-photo-8617761.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1100&w=900&fit=crop",
    // Group — three diverse young men laughing together (multi-ethnic)
    group: "https://images.pexels.com/photos/8423400/pexels-photo-8423400.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200&fit=crop",
    // Background for CTA bands
    bg: "https://images.pexels.com/photos/8423435/pexels-photo-8423435.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600&fit=crop",
    // Community — diverse hands joined together
    community:
        "https://images.pexels.com/photos/1198171/pexels-photo-1198171.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    forestPath:
        "https://images.unsplash.com/photo-1592859600972-1b0834d83747?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxmb3Jlc3QlMjBwYXRofGVufDB8fHx8MTc3OTY1NjEwNnww&ixlib=rb-4.1.0&q=85",
    classroom:
        "https://images.pexels.com/photos/8617744/pexels-photo-8617744.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200&fit=crop",
    handshake:
        "https://images.pexels.com/photos/6147254/pexels-photo-6147254.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200&fit=crop",
};

export const BTN = {
    primary:
        "inline-flex items-center justify-center gap-2 rounded-full bg-[#0E2A47] text-white px-7 py-3.5 text-[14.5px] font-medium hover:bg-[#08182B] transition-colors",
    secondary:
        "inline-flex items-center justify-center gap-2 rounded-full bg-[#C8A24A] text-[#1A2230] px-7 py-3.5 text-[14.5px] font-medium hover:bg-[#a6873a] hover:text-white transition-colors",
    outline:
        "inline-flex items-center justify-center gap-2 rounded-full border border-[#0E2A47] text-[#0E2A47] px-7 py-3.5 text-[14.5px] font-medium hover:bg-[#0E2A47] hover:text-white transition-colors",
    ghost:
        "inline-flex items-center justify-center gap-2 rounded-full bg-white border border-[#E5DFD3] text-[#1A2230] px-7 py-3.5 text-[14.5px] font-medium hover:border-[#0E2A47] transition-colors",
};

export const BRAND = {
    name: "Crossroads to Change Residential Treatment Center",
    short: "Crossroads to Change",
    logo: "/logo.png",
    tagline: "From Trauma to Stability. From Survival to Change.",
    phone: "281.547.8447",
    phoneHref: "tel:+12815478447",
    email: "info@crossroadstochange.com",
    serviceArea: "Serving the Tomball Area",
    location: "Tomball · Greater Houston Area",
    ein: "42-2148581",
};
